import React from 'react';
import { Card, Row, Col, Typography, Divider, Badge } from 'antd';
import {
  CloudOutlined,
  BarChartOutlined,
  LineChartOutlined,
  SafetyOutlined,
  TeamOutlined,
  GlobalOutlined
} from '@ant-design/icons';

const { Title, Paragraph, Text } = Typography;

const HomePage = () => {
  return (
    <div style={{ padding: '20px', background: '#f5f5f5', minHeight: 'calc(100vh - 120px)' }}>
      {/* 系统标题介绍 */}
      <Card style={{ marginBottom: '24px', textAlign: 'center' }}>
        <CloudOutlined style={{ fontSize: '64px', color: '#1890ff', marginBottom: '16px' }} />
        <Title level={1} style={{ color: '#1890ff', marginBottom: '16px' }}>
          智河管理系统
        </Title>
        <Title level={3} style={{ color: '#666', fontWeight: 'normal', marginBottom: '24px' }}>
          智慧流域业务化综合管理平台
        </Title>
        <Paragraph style={{ fontSize: '16px', color: '#666', maxWidth: '800px', margin: '0 auto' }}>
          基于大数据和人工智能技术，集成流域水文预报、城市用水预测、水资源配置优化等功能，
          为水务管理提供科学决策支持，助力智慧城市水资源可持续发展。
        </Paragraph>
      </Card>

      {/* 系统功能模块 */}
      <Row gutter={[24, 24]} style={{ marginBottom: '24px' }}>
        <Col xs={24} md={8}>
          <Card 
            hoverable
            style={{ height: '100%' }}
            cover={
              <div style={{ 
                height: '200px', 
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <LineChartOutlined style={{ fontSize: '80px', color: 'white' }} />
              </div>
            }
          >
            <Badge.Ribbon text="已上线" color="green">
              <Card.Meta
                title={<Text style={{ fontSize: '18px' }}>流域水文预报</Text>}
                description={
                  <div>
                    <Paragraph style={{ marginBottom: '12px' }}>
                      基于集成学习的多模型多尺度珠江典型水文站业务化预测系统，
                      支持多个站点、不同时间尺度的水文数据预报分析。
                    </Paragraph>
                    <Text type="secondary">
                      • 支持高道、坪石、韶关等多个水文站点<br/>
                      • 提供天、月、年多时间尺度预测<br/>
                      • 集成LSTM、CNN、SVM等多种预测模型
                    </Text>
                  </div>
                }
              />
            </Badge.Ribbon>
          </Card>
        </Col>

        <Col xs={24} md={8}>
          <Card 
            hoverable
            style={{ height: '100%' }}
            cover={
              <div style={{ 
                height: '200px', 
                background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <BarChartOutlined style={{ fontSize: '80px', color: 'white' }} />
              </div>
            }
          >
            <Badge.Ribbon text="已上线" color="red">
              <Card.Meta
                title={<Text style={{ fontSize: '18px' }}>城市用水预测</Text>}
                description={
                  <div>
                    <Paragraph style={{ marginBottom: '12px' }}>
                      城市用水数据分析与预测系统，支持多城市多指标的用水量分析，
                      为城市用水规划提供数据支撑。
                    </Paragraph>
                    <Text type="secondary">
                      • 覆盖广州、深圳、东莞等主要城市<br/>
                      • 支持用水量、人口、GDP等多指标分析<br/>
                      • 提供历史趋势和对比分析功能
                    </Text>
                  </div>
                }
              />
            </Badge.Ribbon>
          </Card>
        </Col>

        <Col xs={24} md={8}>
          <Card 
            hoverable
            style={{ height: '100%' }}
            cover={
              <div style={{ 
                height: '200px', 
                background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <SafetyOutlined style={{ fontSize: '80px', color: 'white' }} />
              </div>
            }
          >
            <Badge.Ribbon text="已上线" color="orange">
              <Card.Meta
                title={<Text style={{ fontSize: '18px' }}>区域水资源配置</Text>}
                description={
                  <div>
                    <Paragraph style={{ marginBottom: '12px' }}>
                      区域水资源优化配置系统，基于供需平衡分析，
                      为水资源调配和管理决策提供科学支撑。
                    </Paragraph>
                    <Text type="secondary">
                      • 水资源供需分析与预测<br/>
                      • 多目标优化配置方案<br/>
                      • 风险评估和应急响应策略
                    </Text>
                  </div>
                }
              />
            </Badge.Ribbon>
          </Card>
        </Col>
      </Row>

      {/* 系统特色 */}
      <Card title="系统特色" style={{ marginBottom: '24px' }}>
        <Row gutter={[32, 24]}>
          <Col xs={24} md={12}>
            <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '16px' }}>
              <GlobalOutlined style={{ fontSize: '24px', color: '#1890ff', marginRight: '12px', marginTop: '4px' }} />
              <div>
                <Title level={4} style={{ marginBottom: '8px' }}>多尺度集成预测</Title>
                <Text type="secondary">
                  集成多种机器学习算法，支持不同时空尺度的水文水资源预测，提高预测精度和稳定性。
                </Text>
              </div>
            </div>
            
            <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '16px' }}>
              <BarChartOutlined style={{ fontSize: '24px', color: '#52c41a', marginRight: '12px', marginTop: '4px' }} />
              <div>
                <Title level={4} style={{ marginBottom: '8px' }}>智能数据分析</Title>
                <Text type="secondary">
                  基于大数据技术的智能分析引擎，支持多维数据的关联分析和趋势预测。
                </Text>
              </div>
            </div>
          </Col>

          <Col xs={24} md={12}>
            <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '16px' }}>
              <SafetyOutlined style={{ fontSize: '24px', color: '#faad14', marginRight: '12px', marginTop: '4px' }} />
              <div>
                <Title level={4} style={{ marginBottom: '8px' }}>可视化决策支持</Title>
                <Text type="secondary">
                  丰富的图表展示和交互式数据探索，为管理决策提供直观的可视化支持。
                </Text>
              </div>
            </div>
            
            <div style={{ display: 'flex', alignItems: 'flex-start' }}>
              <TeamOutlined style={{ fontSize: '24px', color: '#eb2f96', marginRight: '12px', marginTop: '4px' }} />
              <div>
                <Title level={4} style={{ marginBottom: '8px' }}>协同管理平台</Title>
                <Text type="secondary">
                  支持多用户协同工作，提供完整的权限管理和数据共享机制。
                </Text>
              </div>
            </div>
          </Col>
        </Row>
      </Card>

      {/* 技术支撑 */}
      <Card>
        <Row gutter={[24, 24]}>
          <Col xs={24} md={16}>
            <Title level={3} style={{ marginBottom: '16px' }}>技术支撑</Title>
            <Paragraph style={{ fontSize: '16px', lineHeight: '1.8' }}>
              智河管理系统依托<Text strong>中山大学地理科学与规划学院</Text>在水文水资源领域的深厚积累，
              结合前沿的人工智能和大数据技术，构建了完整的智慧水务解决方案。
            </Paragraph>
            <Paragraph style={{ fontSize: '16px', lineHeight: '1.8' }}>
              系统采用现代化的Web技术架构，具备良好的扩展性和稳定性，
              能够适应不同规模和复杂度的水务管理需求。
            </Paragraph>
            <Divider />
            <Text type="secondary">
              版本：V1.25 | 更新时间：2025年 | 技术支持：中山大学地理科学与规划学院 孙伟课题组

            </Text>     
          </Col>
          
          <Col xs={24} md={8}>
            <div style={{
              height: '200px',
              background: 'linear-gradient(45deg, #667eea 0%, #764ba2 100%)',
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              fontSize: '18px',
              textAlign: 'center'
            }}>
              <div>
                <CloudOutlined style={{ fontSize: '48px', marginBottom: '16px' }} />
                <div>智慧水务</div>
                <div>科技创新</div>
              </div>
            </div>
          </Col>
        </Row>
      </Card>

      {/* 页脚备案链接 */}
      <div style={{ textAlign: 'center', marginTop: '16px', padding: '12px 0', color: '#888' }}>
        <a href="http://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">豫ICP备2025146253号</a>
      </div>
    </div>
  );
};

export default HomePage;